// extracted by mini-css-extract-plugin
module.exports = {"page":"LiveList_page__1KKOY","mainTable":"LiveList_mainTable__1iYRS"};